export default [
    {
        "treshold": 90000,
        "display": 90000,
        "prisbasbelopp": 2.00
    },
    {
        "treshold": 135000,
        "display": 90000,
        "prisbasbelopp": 3.00
    },
    {
        "treshold": 185000,
        "display": 90000,
        "prisbasbelopp": 4.00
    },
    {
        "treshold": 230000,
        "display": 90000,
        "prisbasbelopp": 5.00
    },
    {
        "treshold": 275000,
        "display": 90000,
        "prisbasbelopp": 6.00
    },
    {
        "treshold": 325000,
        "display": 90000,
        "prisbasbelopp": 7.00
    },
    {
        "treshold": 370000,
        "display": 90000,
        "prisbasbelopp": 8.00
    },
    {
        "treshold": 415000,
        "display": 90000,
        "prisbasbelopp": 9.00
    },
    {
        "treshold": 465000,
        "display": 90000,
        "prisbasbelopp": 10.00
    },
    {
        "treshold": 510000,
        "display": 90000,
        "prisbasbelopp": 11.00
    },
    {
        "treshold": 555000,
        "display": 90000,
        "prisbasbelopp": 12.00
    },
    {
        "treshold": 600000,
        "display": 90000,
        "prisbasbelopp": 13.00
    },
    {
        "treshold": 650000,
        "display": 90000,
        "prisbasbelopp": 14.00
    },
    {
        "treshold": 695000,
        "display": 90000,
        "prisbasbelopp": 15.00
    },
    {
        "treshold": 740000,
        "display": 90000,
        "prisbasbelopp": 16.00
    },
    {
        "treshold": 790000,
        "display": 90000,
        "prisbasbelopp": 17.00
    },
    {
        "treshold": 835000,
        "display": 90000,
        "prisbasbelopp": 18.00
    },
    {
        "treshold": 880000,
        "display": 90000,
        "prisbasbelopp": 19.00
    },
    {
        "treshold": 930000,
        "display": 90000,
        "prisbasbelopp": 20.00
    },
    {
        "treshold": 975000,
        "display": 90000,
        "prisbasbelopp": 21.00
    },
    {
        "treshold": 1000000,
        "display": 90000,
        "prisbasbelopp": 22.00
    },
    {
        "treshold": 1000001,
        "display": 90000,
        "prisbasbelopp": null
    }
]
